import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Col, Button, Row } from 'react-bootstrap';
import _ from 'lodash';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { connect } from 'react-redux';
import EditorMediathekFTs from './EditorMediathekFTs';
import Tabs from '../../components/layout/Tabs';
import MediaLibraryCreacheck from '../../components/layout/mediaLibrary/MediaLibraryCreacheck';
import FormInput from '../../components/forms/FormInput';
const MediaTabs = props => {
    var _a, _b;
    const [descr, setDescr] = useState('');
    const { appIntl, intl } = props;
    const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : intl === null || intl === void 0 ? void 0 : intl.messages;
    function changeDescr(name, value) {
        setDescr(value);
    }
    const saveDescr = () => {
        const index = _.findIndex(props.usedMedia, (media) => media.thumb === props.attributes);
        props.saveDescription(descr, index);
        props.handleIEclose();
    };
    const getTabContentList = () => {
        var _a, _b;
        const result = [];
        const index = _.findIndex(props.usedMedia, (media) => media.thumb === props.attributes);
        const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
        result.push(_jsxs("div", { id: "contextModalNewMedia", className: "col-md-2", children: [props.originalSrc !== '' && (_jsxs("div", { id: "contextModalReuse", className: "modalReuse", children: [_jsx("h5", { children: messages.editor.currently_used_image }), _jsx("div", { id: "preview_used_image", children: _jsx("img", { src: props.originalSrc, alt: "Vorschau" }) }), _jsx(Button, { variant: "info", size: "lg", onClick: e => props.loadOriginal(e, false), className: "crop", children: messages.editor.new_cut }), _jsxs("div", { className: "editDescription", children: [_jsx(FormInput, { type: "text", label: messages.editor.image_description, name: "description", onChange: changeDescr, value: props.usedMedia[index].imgDescription || props.usedMedia[index].img_description }), _jsx(Button, { variant: "info", size: "lg", onClick: saveDescr, className: "upload", children: messages.editor.take_on })] })] })), _jsxs("div", { id: "contextModalNewImage", className: "modalNewImage", children: [_jsx("h5", { children: messages.editor.upload_new_image }), _jsx("div", { className: "new_upload", children: _jsx("i", { className: "fad fa-cloud-upload-alt", style: { fontSize: '15vw', lineHeight: 1 } }) }), _jsx(Button, { variant: "info", size: "lg", onClick: e => props.handleFileUpload(e, true), className: "upload", children: messages.editor.choose_file })] })] }));
        if (!props.rootUser) {
            result.push(_jsx(MediaLibraryCreacheck, { handleMedia: props.handleMedia, neededHeight: props.neededHeight, neededWidth: props.neededWidth, allowSmallerImages: props.allowSmallerImages }));
        }
        else {
            result.push(_jsx(MediaLibraryCreacheck, { handleMedia: props.handleMedia, neededHeight: props.neededHeight, neededWidth: props.neededWidth, allowSmallerImages: props.allowSmallerImages }));
            // result.push(<p>Mediathek deaktiviert für Creacheck im Moment</p>);
        }
        // result.push(<PixabayApi handleMedia={props.handleMedia} neededHeight={props.neededHeight} neededWidth={props.neededWidth}/>);
        result.push(_jsx(EditorMediathekFTs, { usedMedia: props.usedMedia, loadMedia: props.loadMedia, neededWidth: props.neededWidth, neededHeight: props.neededHeight, rootUser: props.rootUser }));
        return result;
    };
    const getTabHeaderList = () => {
        var _a, _b;
        const messages = (_b = (_a = appIntl === null || appIntl === void 0 ? void 0 : appIntl.messages) === null || _a === void 0 ? void 0 : _a.messages) !== null && _b !== void 0 ? _b : {};
        const result = [];
        result.push(messages.editor.image_upload);
        result.push(messages.editor.mediathek);
        //result.push("Pixabay");
        result.push(messages.editor.used_images);
        return result;
    };
    const getTabKeepMounted = () => {
        const keepMounted = [0, 1];
        return keepMounted;
    };
    return (_jsx(_Fragment, { children: _jsx(Row, { children: _jsx(Col, { className: "tabsMediaLibrary", children: _jsx(Tabs, { tabs: getTabHeaderList(), tabContent: getTabContentList(), keepMounted: getTabKeepMounted() }) }) }) }));
};
const mapStateToProps = (state) => {
    return {
        appIntl: state.intl,
    };
};
export default withRouter(connect(mapStateToProps)(legacyInjectIntl(MediaTabs)));
